import { call, put } from "redux-saga/effects";
import { requestGetActivities, requestObjectActivity, requestUserActivity, requestAccountActivity, requestClientActivity } from "../requests/activity";
import { showAlert } from "../../slices/alerts";
import { safeErrorMessage } from '../../../utils/errorUtils';

export function* handleGetActivities(action) {
    try {
        const { callback } = action.payload;
        const response = yield call(requestGetActivities);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetObjectActivity(action) {
    try {
        const { parentType, parentId, callback, page, limit } = action.payload;
        const response = yield call(requestObjectActivity, parentType, parentId, page, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetUserActivity(action) {
    try {
        const { userId, callback, page, limit } = action.payload;
        const response = yield call(requestUserActivity, userId, page, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetAccountActivity(action) {
    try {
        const { accountId, callback, page, limit } = action.payload;
        const response = yield call(requestAccountActivity, accountId, page, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}

export function* handleGetClientActivity(action) {
    try {
        const { clientId, callback, page, limit } = action.payload;
        const response = yield call(requestClientActivity, clientId, page, limit);
        if (callback) {
            callback(response.data);
        }
    } catch (error) {
        yield put(showAlert({ severity: 'error', message: safeErrorMessage(error) }));
    }
}